import styled from 'styled-components';

interface Props {
  color?: string;
  height?: string;
  lineHeight?: string;
  fontSize?: string;
}
export const ContainerStyled = styled.div<Props>`
  
  .dropdown.dropdown-simple{

    &.show{
      .dropdown-toggle::after{
        transform: rotateX(180deg);
      }
    }

    .dropdown-toggle{
      min-width: 132px;
      height: ${({ height }) => height || '36px'};
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: ${({ color }) => color || '#4A90E2'};
      border-radius: 18px;
      border: 0;      
      font-style: normal;
      font-weight: bold;
      font-size: ${({ fontSize }) => fontSize || '12px'};
      line-height: ${({ lineHeight }) => lineHeight || '10px'};
      letter-spacing: 0.5px;      
      color: #FFFFFF;
    }

    .dropdown-menu{
      min-width: 100%;      
      background: #FFFFFF;
      box-shadow: 0px 5px 15px rgba(0, 34, 102, 0.3);
      border-radius: 4px;
      margin-top: 2px !important;
      padding: 0;

      .dropdown-item{
        font-style: normal;
        font-weight: bold;
        font-size: 12px;
        line-height: 13px;
        color: #475466;
        padding: 14px;
        border-bottom: 1px solid #E4E9F0;
        white-space: normal;

        &:last-child{
          border: 0;
        }

        &:hover,&.active,&:active{
          color: #FFFFFF;
          background-color: #4A90E2;
        }
      }
    }
  }
`;
